export default __webpack_public_path__ + "static/media/instagram-logo.04e0522f.png";